<template>
  <div>
    <div class="main-width">
      <div>
        <div style="margin: 30px 0 10px; font-size: 12px; color: #bca365">
          <div style="text-align: right;">
            <div style="float: left;">提示：报价表最多可加入200件商品</div>
            <div
              style="
                line-height: 30px;
                display: inline-block;
                margin: 0;
                height: 30px;
                padding: 0 10px;
                border: none;
              "
              class="get-price-label"
              @click="oneKeyDeleteGoodsMore"
            >
              一键清除失效商品
            </div>
            <div
              style="
                line-height: 30px;
                display: inline-block;
                margin: 0;
                height: 30px;
                padding: 0 10px;
                margin-left: 20px;
              "
              class="get-price-label"
              @click="deleteGoodsMore"
            >
              批量移出报价表
            </div>
            <el-button style="background-color: #ffa726;border-color: #ffa726;margin-left: 20px;" type="danger" size="small"  v-loading="loading.export" @click="exportFn">导出报价表</el-button>
          </div>
        </div>
        <el-table
          v-show="hasGoods"
          :data="tableData"
          tooltip-effect="dark"
          fit
          class="table-static th-eee"
          :class="fixedBool == true ? 'table-fixed' : ''"
          id="table-scroll"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            label="全选"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="orderNo"
            label="排序"
            align="center"
            width="80"
          >
            <template slot-scope="scope">
              <template v-if="scope.row.goodsVo">
              <el-input
                @blur="orderNoFn(scope.row)"
                v-model="scope.row.orderNo"
                placeholder=""
              ></el-input>
              </template>
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            label="商品信息"
            align="center"
            min-width="350"
          >
            <template slot-scope="scope">
              <template v-if="scope.row.goodsVo">
              <div class="goods-info">
                <div class="goods-img-box">
                  <router-link
                    tag="a"
                    target="_blank"
                    :to="{
                      name: 'Detail',
                      query: { goodsId: scope.row.goodsVo.goodsId },
                    }"
                  >
                    <div class="goods-img">
                      <img
                        :src="scope.row.goodsVo.goodsPicture"
                        @error="error(1)"
                      />
                      <!-- <div
                        class="category-cover-image"
                        :class="{ a: scope.row.goodsVo.hasTax == 1 }"
                      ></div> -->
                    </div>
                  </router-link>
                </div>
                <div style="margin-left: 15px; text-align: left">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    v-bind:content="scope.row.goodsVo.goodsName"
                    placement="top"
                  >
                    <div
                      style="
                        font-size: 14px;
                        text-align: left;
                        color: #333;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                      "
                    >
                      {{ scope.row.goodsVo.goodsName }}
                    </div>
                  </el-tooltip>
                  <div
                    style="
                      font-size: 14px;
                      margin: 5px 0;
                      text-align: left;
                      color: #666;
                    "
                  >
                    品牌：{{ scope.row.goodsVo.brandName }}
                  </div>
                  <el-select
                    :disabled="personalitySetting.type != 3"
                    v-model="scope.row.goodsVo.appType"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in appTypeArr"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <!-- <div class="type-icon" style="display: inline-block;line-height: 22px;text-align: center;" v-if="scope.row.goodsVo.appType == 2">社群集采</div>
                    <div class="type-icon" style="display: inline-block;line-height: 22px;text-align: center;" v-if="scope.row.goodsVo.appType == 1">一件代发</div> -->
                  <div
                    class="type-icon"
                    style="
                      background-color: rgb(231, 249, 235);
                      color: rgb(88, 191, 106);
                      margin-top: 10px;
                      display: inline-block;
                      line-height: 22px;
                      text-align: center;
                    "
                    v-if="scope.row.goodsVo.isSelf == 1"
                  >
                    自产自销
                  </div>
                </div>
              </div>
              </template>
              <template v-else>商品失效了</template>
            </template>
          </el-table-column>
          <el-table-column
            prop="productName"
            label="规格"
            align="center"
            width="150"
          >
            <template slot-scope="scope">
              <template v-if="scope.row.goodsVo">
              <template v-if="scope.row.goodsVo.appType == 1">
                <!-- 0一件代发 -->
                <div
                class="line-clamp-1"
                  v-for="(item, index) in scope.row.goodsVo.productLabels"
                  :key="index"
                >
                  {{ item.productName }}
                </div>
              </template>
              <template v-else-if="scope.row.goodsVo.appType == 2">
                <!-- 2社群采 -->
                <div
                class="line-clamp-1"
                  v-for="(item, index) in scope.row.goodsVo
                    .communityProductLabels"
                  :key="index"
                >
                  {{ item.productName }}
                </div>
              </template>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="" align="center">
            <template slot="header" slot-scope="{ column, $index }">
              <el-select
                v-model="piao"
                placeholder="请选择"
                :disabled="personalitySetting.goodsTaxDisplayType != 0"
              >
                <el-option
                  v-for="item in piaoArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </template>
            <el-table-column
              prop="status"
              label="建议零售价"
              align="center"
              width="160"
            >
              <template slot-scope="scope">
                <template v-if="scope.row.goodsVo">
                <template v-if="scope.row.goodsVo.appType == 1">
                  <!-- 0一件代发 -->
                  <div
                    v-for="(item, index) in scope.row.goodsVo.productLabels"
                    :key="index"
                  >
                    ￥{{ item.salePrice / 100 }}
                  </div>
                </template>
                <template v-else-if="scope.row.goodsVo.appType == 2">
                  <!-- 2社群采 -->
                  <div
                    v-for="(item, index) in scope.row.goodsVo
                      .communityProductLabels"
                    :key="index"
                  >
                    ￥{{ item.salePrice / 100 }}
                  </div>
                </template>

                <el-tooltip
                v-if="scope.row.priceLimit == 1"
                      class="item"
                      effect="dark"
                      content="该商品品牌方控价，请不要低于建议售价对外销售，擅自降价将会终止供应链供货。"
                      placement="top"
                    >
                      <span class="price-limit-tab">零售控价</span>
                    </el-tooltip>
                </template>
              </template>
            </el-table-column>
            <el-table-column
              prop="status"
              label="结算价（+运费）"
              align="center"
              width="160"
            >
              <!-- <template slot="header" slot-scope="{ column, $index }">
                <div v-if="scope.row.goodsVo.appType == 0">结算价（+运费）</div>
                <div v-else-if="scope.row.goodsVo.appType == 2">结算价</div>
              </template> -->
              <template slot-scope="scope">
                <template v-if="scope.row.goodsVo">
                <template v-if="scope.row.goodsVo.appType == 1">
                  <!-- 0一件代发 -->
                  <div
                    v-for="(item, index) in scope.row.goodsVo.productLabels"
                    :key="index"
                  >
                    <template v-if="piao == 1">
                      <!-- 带票 -->
                      ￥{{ item.taxCooperatePrice / 100 }}(+{{item.fright / 100}})
                    </template>
                    <template v-else-if="piao == 2">
                      <!-- 不带票 -->
                      ￥{{ item.cooperatePrice / 100 }}(+{{item.fright / 100}})
                    </template>
                  </div>
                </template>
                <template v-else-if="scope.row.goodsVo.appType == 2">
                  <!-- 2社群采 -->
                  <div
                    v-for="(item, index) in scope.row.goodsVo
                      .communityProductLabels"
                    :key="index"
                  >
                    <template v-if="piao == 1">
                      <!-- 带票 -->
                      ￥{{ item.taxCooperatePrice / 100 }}
                    </template>
                    <template v-else-if="piao == 2">
                      <!-- 不带票 -->
                      ￥{{ item.cooperatePrice / 100 }}
                    </template>
                  </div>
                </template>
                </template>
              </template>
            </el-table-column>
            <el-table-column
              prop="status"
              label="毛利"
              align="center"
              width="100"
            >
              <template slot-scope="scope">
                <template v-if="scope.row.goodsVo">
                <template v-if="scope.row.goodsVo.appType == 1">
                  <!-- 0一件代发 -->
                  <div
                    v-for="(item, index) in scope.row.goodsVo.productLabels"
                    :key="index"
                  >
                    <template v-if="piao == 1">
                      <!-- 带票 -->
                      ￥{{ item.taxProfitValue / 100 }}
                    </template>
                    <template v-else-if="piao == 2">
                      <!-- 不带票 -->
                      ￥{{ item.profitValue / 100 }}
                    </template>
                  </div>
                </template>
                <template v-else-if="scope.row.goodsVo.appType == 2">
                  <!-- 2社群采 -->
                  <div
                    v-for="(item, index) in scope.row.goodsVo
                      .communityProductLabels"
                    :key="index"
                  >
                    <template v-if="piao == 1">
                      <!-- 带票 -->
                      ￥{{ item.taxProfitValue / 100 }}
                    </template>
                    <template v-else-if="piao == 2">
                      <!-- 不带票 -->
                      ￥{{ item.profitValue / 100 }}
                    </template>
                  </div>
                </template>
                </template>
              </template>
            </el-table-column>
            <el-table-column
              prop="status"
              label="毛利率"
              align="center"
              width="100"
            >
              <template slot-scope="scope">
                <template v-if="scope.row.goodsVo">
                <template v-if="scope.row.goodsVo.appType == 1">
                  <!-- 0一件代发 -->
                  <div
                    v-for="(item, index) in scope.row.goodsVo.productLabels"
                    :key="index"
                  >
                    <template v-if="piao == 1">
                      <!-- 带票 -->
                      {{ item.taxProfitMargin }}%
                    </template>
                    <template v-else-if="piao == 2">
                      <!-- 不带票 -->
                      {{ item.profitMargin }}%
                    </template>
                  </div>
                </template>
                <template v-else-if="scope.row.goodsVo.appType == 2">
                  <!-- 2社群采 -->
                  <div
                    v-for="(item, index) in scope.row.goodsVo
                      .communityProductLabels"
                    :key="index"
                  >
                    <template v-if="piao == 1">
                      <!-- 带票 -->
                      {{ item.taxProfitMargin }}%
                    </template>
                    <template v-else-if="piao == 2">
                      <!-- 不带票 -->
                      {{ item.profitMargin }}%
                    </template>
                  </div>
                </template>
                </template>
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column
            prop="status"
            label="操作"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              <template v-if="scope.row.goodsVo">
                <div class="delete-btn-2" @click="deleteGoods(scope.row)">
                  <i class="el-icon-delete"></i>
                </div>
              </template>

            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-show="hasGoods">
          <el-pagination
            layout="total, sizes, prev, pager, next"
            :page-sizes="[30, 60, 100]"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pageNum"
            :total="pageTotal"
            :page-size="pageSize"
          ></el-pagination>
        </div>
      </div>
      <div class="category-goods-wrap-no" v-show="!hasGoods">
        <div class="category-goods-wrap-tip">没有找到相关商品...</div>
      </div>
    </div>
    <el-dialog
    title="导出提示"
    :visible.sync="dialogVisible"
    width="600px"
    :show-close="false"
    :before-close="handleClose">
    <span>导出任务正在生成，请前往【下载列表】中下载您已导出的信息</span>
    <span slot="footer" class="dialog-footer">
      <el-button style="background-color: #ffa726;border-color: #ffa726" type="primary" @click="dialogVisible = false" >好的，我知道了</el-button>
    </span>
  </el-dialog>
    <el-dialog
      title=""
      :visible.sync="dialogVisible2"
      width="600px"
      :before-close="handleClose2"
      :show-close="false"
    >
      <div style="text-align: center">
        成功添加商品到“报价篮子”，可以前往“报价篮子”批量导出商品报价！
      </div>
      <span slot="footer" class="dialog-footer">
        <div
          class="category-goods-add-default"
          style="width: 200px; margin: 0 auto"
          @click="dialogVisible2 = false"
        >
          我知道了
        </div>
      </span>
    </el-dialog>
    <el-dialog
      title="导出"
      :visible.sync="dialogVisible3"
      width="600px"
      :before-close="handleClose3"
      :show-close="false"
    >
      <div>
        <el-form
        :model="formDatas"
        :rules="formRules"
        ref="formDatas"
        label-position="left"
        size="small"
        >
        <el-form-item label="带票类型：" prop="hasTax" :label-width="formLabelWidth">
          <el-checkbox-group v-model="formDatas.hasTax">
            <el-checkbox :disabled="personalitySetting.goodsTaxDisplayType == 2" :label="2">带票</el-checkbox>
            <el-checkbox :disabled="personalitySetting.goodsTaxDisplayType == 1" :label="1">不带票</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="库存类型：" prop="supplyChannel" :label-width="formLabelWidth">
          <el-checkbox-group v-model="formDatas.supplyChannel">
            <el-checkbox :disabled="personalitySetting.type == 2" :label="1">一件代发</el-checkbox>
            <el-checkbox :disabled="personalitySetting.type == 0" :label="2">社群集采</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        </el-form>
      </div>
      <div slot="footer" style="text-align: center;">
        <el-button style="background-color: #ffa726;border-color: #ffa726;margin-left: 20px;width: 100px" type="danger" size="small"  @click="onSubmit('formDatas')">导出报价表</el-button>
        <div
              style="
                line-height: 30px;
                display: inline-block;
                margin: 0;
                height: 30px;
                padding: 0 10px;
                margin-left: 20px;
                border-color: #ffa726;
                color: #ffa726;
                width: 100px;
              "
              class="get-price-label"
              @click="dialogVisible3 = false"
            >
              取消
            </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import store from "../store/index.js";
import {
  getLabelInfo,
  selectGoodsAppReportList,
  addNewShelves,
  exportAppGoodsReport,
  updateReport,
  deleteGoodsReport,
  getPersonalitySetting,
  updateIdentityOrder,
} from "../config/interface.js";
import { toast, imageError } from "../util/tool.js";
import { fetch } from "../config/fetch.js";
import router from "../router/index.js";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      hasGoods: true,
      pageTotal: 0,
      pageNum: 1,
      pageSize: 60,
      tableData: [],
      labelValue: [],
      labelOrigin: [],
      queryFlag: {
        // 是否可发送请求
        export: true,
      },
      loading: {
        // 是否显示loading
        export: false,
      },
      dialogVisible: false,
      dialogVisible2: false,
      dialogVisible3: false,
      goodsName: null,
      brandName: null,
      multipleSelection: [],
      piao: 1,
      piaoArr: [
        {
          value: 1,
          label: "带票",
        },
        {
          value: 2,
          label: "不带票",
        },
      ],
      appTypeArr: [
        {
          value: 1,
          label: "一件代发",
        },
        {
          value: 2,
          label: "社群集采",
        },
      ],
      personalitySetting: {
        goodsTaxDisplayType: null,
        type: null,
      },
      fixedBool: false,

      formDatas: {
        hasTax: [],
        supplyChannel: [],
      },
      formRules: {
        hasTax: [
          {
            required: true,
            message: "必选",
            trigger: "blur"
          }
        ],
         supplyChannel: [
          {
            required: true,
            message: "必选",
            trigger: "blur"
          }
        ]
      },
      formLabelWidth: "120px",

    };
  },
  created() {},
  computed: {},
  watch: {
    $route(to, from) {
      console.log("路由改变");
      location.reload(true);
    },
  },
  mounted() {
    this.showDispalyType();
    this.getLabelInfo();
    this.init();
    window.addEventListener("scroll", this.onScroll);
  },
  updated() {},
  methods: {
    // 导出
    exportFn() {
      this.dialogVisible3 = true;
    },
    // 提交保存
    onSubmit(formDatas) {
      let _this = this;
      this.$refs[formDatas].validate(valid => {
        if (valid) {
          if(_this.formDatas.hasTax.length == 0){
            toast("请选择带票类型", 3, false);
            return false;
          }
          if(_this.formDatas.supplyChannel.length == 0){
            toast("请选择库存类型", 3, false);
            return false;
          }
          this.handleExport()
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleExport() {
      let url = exportAppGoodsReport;
      let _this = this;
      if (this.queryFlag.export == true) {
        this.queryFlag.export = false;
        this.loading.export = true;
        let params = {
          appId: this.$store.state.appId,
          userId: this.$store.state.userId,
          hasTax: _this.formDatas.hasTax.length >= 2 ? 0 : _this.formDatas.hasTax[0],
          supplyChannel: _this.formDatas.supplyChannel.length >= 2 ? 0 : _this.formDatas.supplyChannel[0],
        };
        let responseType = "arraybuffer";
        fetch(url, params, responseType)
          .then(res => {

            this.dialogVisible3 = false;
            _this.queryFlag.export = true;
            _this.loading.export = false;
            this.dialogVisible = true;
          })
          .catch(function(err) {
            toast("导出失败！", 2, false);
          });
      }
    },
    orderNoFn(row) {
      let _this = this;
      let moveRange = 0; //移动范围
      let moveType = 1; // moveType: MOVE_TOP-1 MOVE_END-2 MOVE_UP-3 MOVE_DOWN-4
      if (row.orderNo * 1 == 1) {
        moveRange = 0;
      } else {
        moveRange = row.orderNo * 1 - row.orderNoOld * 1;
        if (moveRange == 0) {
          return false;
        }
        if (moveRange < 0) {
          moveType = 3;
        } else if (moveRange > 0) {
          moveType = 4;
        }
      }
      var data = {
        appId: this.$store.state.appId,
        goodsAppReportId: row.id,
        moveRange: Math.abs(moveRange),
        moveType: moveType,
      };
      fetch(updateIdentityOrder, data).then((res) => {
        if(res.code == 10000){
          toast("成功", 1, false);
          _this.init();
        }
      });
    },
    showDispalyType() {
      fetch(getPersonalitySetting, {
        userId: this.$store.state.userId,
        appId: this.$store.state.appId,
      }).then((res) => {
        this.personalitySetting.goodsTaxDisplayType =
          res.data.goodsTaxDisplayType; // 0带票&不带票全部展示 1仅展示带票商品 2仅展示不带票商品
        this.personalitySetting.type = res.data.type; //0一件代发  2社群采 3一件代发&社群采
        this.piao = res.data.goodsTaxDisplayType;
        if (res.data.goodsTaxDisplayType == 0) {
          this.piao = 1;
        }
        let typeArr1 = [0,2,1];
        this.formDatas.hasTax = res.data.goodsTaxDisplayType == 0 ? [2] : [typeArr1[res.data.goodsTaxDisplayType]];
        let typeArr2 = [1,0,2];
        this.formDatas.supplyChannel = res.data.type == 3 ? [1] : [typeArr2[res.data.type]]
      });
    },
    // 选中行
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    deleteGoodsMore() {
      let _this = this;
      let reportList = [];
      this.multipleSelection.forEach((item, index) => {
        let obj = {};
        obj.appId = item.appId;
        obj.appType = item.appType;
        obj.goodsId = item.goodsId;
        obj.haxTax = item.haxTax;
        obj.id = item.id;
        obj.orderNo = item.orderNo;
        reportList.push(obj);
      });
      var data = {
        reportList: reportList,
        appId: this.$store.state.appId,
        removeOrderNo: 1,
      };
      fetch(deleteGoodsReport, data).then((res) => {
        if(res.code == 10000){
        toast("删除成功", 1, false);
        _this.init();
        }
      });
    },
    oneKeyDeleteGoodsMore() {
      let _this = this;
      let reportList = [];
      this.tableData.forEach((item, index) => {
        if (!item.goodsVo) {
        let obj = {};
        obj.appId = item.appId;
        obj.appType = item.appType;
        obj.goodsId = item.goodsId;
        obj.haxTax = item.haxTax;
        obj.id = item.id;
        obj.orderNo = item.orderNo;
        reportList.push(obj);
        }
      });
      var data = {
        reportList: reportList,
        appId: this.$store.state.appId,
        removeOrderNo: 1,
      };
      fetch(deleteGoodsReport, data).then((res) => {
        if(res.code == 10000){
        toast("删除成功", 1, false);
        _this.init();
        }
      });
    },
    deleteGoods(row) {
      let _this = this;
      let reportList = [];
      let obj = {};
      obj.appId = row.appId;
      obj.appType = row.appType;
      obj.goodsId = row.goodsId;
      obj.haxTax = row.haxTax;
      obj.id = row.id;
      obj.orderNo = row.orderNo;
      reportList.push(obj);
      var data = {
        reportList: reportList,
        appId: this.$store.state.appId,
        removeOrderNo: 1,
      };
      fetch(deleteGoodsReport, data).then((res) => {
        if(res.code == 10000){
        toast("删除成功", 1, false);
        _this.init();
        }
      });
    },
    getPriceAll() {
      let _this = this;
      let reportList = [];
      this.tableData.forEach((item, index) => {
        let obj = {};
        obj.appId = item.appId;
        obj.appType = item.appType;
        obj.goodsId = item.goodsId;
        obj.haxTax = item.haxTax;
        obj.id = item.id;
        obj.orderNo = item.orderNo;
        reportList.push(obj);
      });
      var data = {
        reportList: reportList,
        appId: this.$store.state.appId,
      };
      fetch(updateReport, data).then((res) => {
        _this.dialogVisible2 = true;
      });
    },
    getPrice(row) {
      let _this = this;
      let reportList = [];
      let obj = {};
      obj.appId = row.appId;
      obj.appType = row.appType;
      obj.goodsId = row.goodsId;
      obj.haxTax = row.haxTax;
      obj.id = row.id;
      obj.orderNo = row.orderNo;
      reportList.push(obj);
      var data = {
        reportList: reportList,
        appId: this.$store.state.appId,
      };
      fetch(updateReport, data).then((res) => {
        _this.dialogVisible2 = true;
      });
    },

    handleClose() {
      this.dialogVisible = true;
    },
    handleClose2() {
      this.dialogVisible2 = true;
    },
    handleClose3() {
      this.dialogVisible3 = true;
    },


    // 重置搜索
    reset() {
      this.init();
    },
    addNewShelvesAll() {
      let goodsList = [];
      this.tableData.forEach((item, index) => {
        if (item.shelvesStatus == 0) {
          item.productLabels.forEach((itm, idx) => {
            let obj = {};
            obj.productId = itm.productId;
            obj.goodsId = item.goodsId;
            obj.hasTax = item.hasTax;
            obj.appType = item.appType;
            goodsList.push(obj);
          });
        }
      });
      let params = {
        goodsList: goodsList,
        userId: this.$store.state.userId,
      };
      fetch(addNewShelves, params).then((res) => {
        if ((res.code = 10000)) {
          toast("加入成功", 1, false);
          this.init();
        } else {
          toast("加入失败", 2, false);
        }
      });
    },
    addNewShelves(row) {
      let goodsList = [];
      row.goodsVo.productLabels.forEach((item, index) => {
        let obj = {};
        obj.productId = item.productId;
        obj.goodsId = row.goodsId;
        obj.hasTax = row.hasTax;
        obj.appType = row.appType;
        goodsList.push(obj);
      });
      let params = {
        goodsList: goodsList,
        userId: this.$store.state.userId,
      };
      fetch(addNewShelves, params).then((res) => {
        if ((res.code = 10000)) {
          toast("加入成功", 1, false);
          this.init();
        } else {
          toast("加入失败", 2, false);
        }
      });
    },
    getLabelInfo() {
      let params = {
        appId: this.$store.state.appId,
        userId: this.$store.state.userId,
      };
      //获取商品
      fetch(getLabelInfo, params).then((res) => {
        if (res.code = 10000) {
          this.labelOrigin = res.data;
        }
      });
    },
    init() {
      let params = {
        appId: this.$store.state.appId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        brandName: this.brandName,
        goodsName: this.goodsName,
        inReport: 1,
      };
      //获取商品
      fetch(selectGoodsAppReportList, params).then((res) => {
        if(res.code == 10000){
        this.tableData = res.data.result;

        this.tableData.forEach((item, index) => {
          item.orderNoOld = item.orderNo;
        });
        if (this.tableData.length == 0) {
          this.hasGoods = false;
        } else {
          this.hasGoods = true;
        }
        this.pageTotal = res.data.count;
        }
      });
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.init();
    },
    // 改变pageSize
    handleSizeChange(val) {
      this.pageSize = val;
      this.init();
    },
     /*滚动监控 start*/
    onScroll() {
       let scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
        if(scrollTop > 84){
          this.fixedBool = true;
        }else{
          this.fixedBool = false;
        }
    },
  },
};
</script>
<style >
.label-popover {
  word-break: normal;
  min-width: auto;
  max-width: 20%;
  color: #fff;
  background: rgba(0, 0, 0, 0.5);
  border: none;
}
.label-popover.el-popper[x-placement^="top"] .popper__arrow::after {
  border-top-color: rgba(0, 0, 0, 0.5);
}
.label-popover.el-popper[x-placement^="bottom"] .popper__arrow::after {
  border-bottom-color: rgba(0, 0, 0, 0.5);
}
.category-cover-image.a {
  background: url(../assets/img/hanshui.png) no-repeat top right/45px 45px;
}
.category-cover-image {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  background: url(../assets/img/buhanshui.png) no-repeat top right/45px 45px;
}
.goods-img {
  position: relative;
  width: 120px;
  height: 120px;
}
.goods-img img {
  width: 100%;
  height: 100%;
}
.table-popover {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: start;
  -webkit-align-items: flex-start;
  align-items: flex-start;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  background-color: #fafafa;
}
.type-icon {
  width: 60px;
  height: 22px;
  background: rgba(255, 248, 249, 1);
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: center;

  margin-right: 10px;
  font-size: 12px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(255, 77, 94, 1);
  line-height: 17px;
}
.goods-info {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.table-label-tip {
  display: inline-block;
  border-width: 1px;
  border-style: solid;
  border-color: #fd7c5d;
  color: #fd7c5d;
  font-size: 12px;
  padding: 0 5px;
  box-sizing: border-box;
  margin: 5px;
}
.th-eee th {
  background-color: #eee;
}
.custom-width {
  width: 200px;
}
.get-price-label {
  margin-top: 10px;
  height: 38px;
  line-height: 40px;
  text-align: center;
  border: 1px solid #fd7c5d;
  color: #fd7c5d;
  cursor: pointer;
  background-color: #fff;
}
.get-price-label.yet {
  background-color: #c0c0c0;
  color: #fff;
  border: 1px solid #c0c0c0;
}
.goods-img-box {
  position: relative;
}
.goods-img-box:hover .delete-btn {
  display: block;
}
.delete-btn-2 {
  width: 30px;
  height: 30px;
  font-size: 16px;
  text-align: center;
  line-height: 30px;
  cursor: pointer;
  color: #f56c6c;
  margin: 0 auto;
}
.table-fixed .el-table__header-wrapper{
  position: fixed;
  top: 300px;
  z-index: 11;
  max-width: 1280px;
}
.price-limit-tab {
  display: inline-block;
  border-width: 1px;
  border-style: solid;
  border-color: #fd7c5d;
  color: #fd7c5d;
  font-size: 12px;
  padding: 0 3px;
  box-sizing: border-box;
  margin: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// PriceLibraryList.vue?bd04a674